/**
 * Represents an individual field section of a `FormView`.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The model associated with the control.
 * field | The `Field` associated with the control.
 *
 * ## Events
 * Name | Arguments | Description
 * change | The new field value | Fires whenever the field value changes.
 * @module app/views/FormInputView
 */
import Backbone from "backbone";
import _ from "underscore";
import s from "underscore.string";
import fieldViewFactory from "core/views/Field/FieldViewFactory";
var FormInputView = Backbone.View.extend({
  className: "form-group",

  template: _.template(
    '<label for="<%-field.attributes.name%>" class="control-label" <%if(field.attributes.description){%> data-toggle="tooltip" title="<%= field.attributes.description %>"<%}%>><%-field.attributes.label%></label><span class="after-label"></span>'
  ),

  /**
   * Initializes the control.
   * @param  {object} options The options hash.
   * @param {Field} options.field The field to associate with this view.
   * @param {mixed} options.model The model to associate with this view.
   */
  initialize: function (options) {
    this.options = options;

    this.field = this.options.field;

    var self = this;

    Object.defineProperty(this, "model", {
      get: function () {
        if (self._editor) {
          return self._editor.model;
        } else {
          return self.options.model;
        }
      },
    });
  },

  /**
   * Propagate the field value from the model to this control.
   * @deprecated
   * @param  {Boolean} [silent] True to prevent a "change" event from firing, otherwise false.
   */
  refresh: function (silent) {},

  /**
   * Propagate the field value from this control to the underlying model.
   * @deprecated
   */
  updateValue: function () {},

  render: function () {
    var customClass = "form-input-view-" + s.slugify(this.field.get("name"));
    var options = _.defaults(
      {
        label_attrs: null,
        input_attrs: null,
        prefix: "",
      },
      this.options,
      {
        after: false,
      }
    );

    this.$el.html(this.template(options));
    this._editor = fieldViewFactory.getEditor(
      this.options.field,
      this.options.model
    );
    this._editor.render();
    this._editor.on(
      "change",
      function () {
        this.trigger("change", this._editor.value);
      },
      this
    );
    this.$(".after-label").after(this._editor.$el);

    if (_.isFunction(options.after)) {
      this._editor.$el.after(options.after(options.model, options.fieldName));
    }
    if (!this.options.field.attributes.visible) {
      this.$el[0].hidden = true;
    } else {
      this.$el[0].hidden = false;
    }
    this.$el.removeClass(customClass).addClass(customClass);
  },

  delegateEvents: function () {
    Backbone.View.prototype.delegateEvents.apply(this, arguments);

    if (this._editor) {
      if (this._editor.delegate) {
        this._editor.delegate();
      }

      if (this._editor.delegateEvents()) {
        this._editor.delegateEvents();
      }
    }
  },

  /**
   * Sets focus to the field of this view associated with the input.
   */
  focus: function () {
    var $el = this.$el.find("input, textarea");
    var text = $el.focus().val();

    $el.val("").val(text);
  },
});

export default FormInputView;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/FormInputView.js
// module id = 30
// module chunks = 1